import { render, staticRenderFns } from "./dataprocess-form2.vue?vue&type=template&id=2c973d4a&scoped=true&"
import script from "./dataprocess-form2.vue?vue&type=script&lang=ts&"
export * from "./dataprocess-form2.vue?vue&type=script&lang=ts&"
import style0 from "./dataprocess-form2.vue?vue&type=style&index=0&id=2c973d4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c973d4a",
  null
  
)

export default component.exports